import { render, staticRenderFns } from "./Changelogs.vue?vue&type=template&id=77e1fa8d"
import script from "./Changelogs.vue?vue&type=script&lang=js"
export * from "./Changelogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports